var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _c("div", { staticClass: "d-flex gap-10" }, [
      _c(
        "div",
        {
          staticClass: "file-action-btn gap-10",
          class: { active: this.resultPage.activeToolGroup === "all" },
          on: {
            click: function ($event) {
              return _vm.setActiveGroup("all")
            },
          },
        },
        [
          _c("i", { staticClass: "far fa-border-all lh-inherit" }),
          _vm._v(" " + _vm._s(_vm._f("trans")("All"))),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "file-action-btn gap-10",
          class: { active: this.resultPage.activeToolGroup === "tools" },
          on: {
            click: function ($event) {
              return _vm.setActiveGroup("tools")
            },
          },
        },
        [
          _c("i", { staticClass: "fa fa-folder-open lh-inherit" }),
          _vm._v(" " + _vm._s(_vm._f("trans")("Tools"))),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "file-action-btn gap-10",
          class: { active: this.resultPage.activeToolGroup === "converter" },
          on: {
            click: function ($event) {
              return _vm.setActiveGroup("converter")
            },
          },
        },
        [
          _c("i", { staticClass: "far fa-file lh-inherit" }),
          _vm._v(" " + _vm._s(_vm._f("trans")("Converter"))),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }